import { Component, Input } from '@angular/core';
import { LocaleDataService } from '../../../../submodules/angular-common/locale-data.service';
import { SelectableOption } from '../../base-types';
import { appearance } from '../../../../config/appearance';

@Component({
  selector: 'app-language-chooser',
  templateUrl: './language-chooser.component.html',
  styleUrls: ['./language-chooser.component.scss']
})
export class LanguageChooserComponent {

  @Input() locales: SelectableOption[]
  @Input() fontColor: string
  @Input() public compact: boolean = false;

  theme = appearance

  constructor(
    public localeDataService: LocaleDataService) 
  { }

  public isSelected = (a, b) => a.split('-').join('_').toLowerCase() == b.split('-').join('_').toLowerCase()

}
